import React, { useState, useEffect } from "react";
import Sidebar from "../../components/sidebar/Sidebar";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import InputBoxV2 from "../../components/inputbox/InputboxV2";
import Abutton from "../../components/button/Abutton";
import ASelectv1 from "../../components/select/ASelectV1";
import InputBoxV1 from "../../components/inputbox/InputBoxV1";
import { postData } from "../../api/apiDataExchange";
import { Link, useNavigate, useParams } from 'react-router-dom';
import { useAuth } from "../../hooks/useAuth";

const AddMeter = () => {
  const { setIsSidebarOpen, isSidebarOpen } = useAuth();

  const [name, setName] = useState("");
  const [org, setOrg] = useState("");
  const [organisationList, setOrganisationList] = useState([]);

  const [factorylist, setFactorylist] = useState([])
  const [unitlist, setUnitlist] = useState([])
  const [factory, setfactory] = useState("")
  const [unit, setunit] = useState("")
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [openPopup, setOpenPopup] = useState(false);
  const [errors, setErrors] = useState([]);


  const [isOpen, setIsOpen] = useState(false);
  const [optSuccess, setOptSuccess] = useState(false);
  const [otp, setOtp] = useState("");
  const [isFormSubmitted, setIsFormSubmitted] = useState(false);
  const [isFormValid, setIsFormValid] = useState(false);
  const [isloading, setIsloading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (event) => {
    event.preventDefault();
    setFormSubmitted(true);
    console.log({ errors });
    const isErrorResolved =
      errors.some((item) => item["EmailError"] === "") &&
      errors.some((item) => item["PasswordError"] === "");

    const allStateData = {
      buyerId: localStorage.getItem('userId'),
      organisationId: org,
      factoryId: factory,
      unitId: unit,
      meterNo: name,
    };
    console.log(allStateData);
    if (allStateData.factoryId != "" && allStateData.organisationId != "" && allStateData.unitId != "" && allStateData.buyerId != "" && allStateData.meterNo != "") {

      const response = await postData(
        `${process.env.REACT_APP_API_URL}/meter/`,
        allStateData
      );

      if (response?.data?.error?.code === 200) {
        toast.success('Meter Successfully Updated', {
          position: "top-center",
          autoClose: 3000
        })
        navigate('/my-data');
      } else {
        toast.error(response.error.response.data.error.message);
      }
      if (isErrorResolved) {
        setOpenPopup(true);
      }
    }
  };

  useEffect(() => {
    const getdata = async () => {

      const allStateData = {
        buyerId: localStorage.getItem('userId'),
      };
      console.log(allStateData);
      const response = await postData(
        `${process.env.REACT_APP_API_URL}/organisation/list`,
        allStateData
      );
      setOrganisationList(response?.data?.data?.results);
    };
    getdata();
  }, []);


  useEffect(() => {
    const getfactorydata = async () => {
      if (org !== "") {
        const orgdata = {
          organisationId: org,
        };
        console.log(orgdata);
        const response = await postData(
          `${process.env.REACT_APP_API_URL}/factory/list`,
          orgdata
        );
        setFactorylist(response?.data?.data?.results);
      }
    };
    getfactorydata();
  }, [org]);

  useEffect(() => {
    const getmeterdata = async () => {
      if (factory !== "") {
        const meterData = {
          unitId: factory,
        };
        console.log(meterData);
        const response = await postData(
          `${process.env.REACT_APP_API_URL}/unit/list`,
          meterData
        );
        setUnitlist(response.data.result);
      }
    };
    getmeterdata();
  }, [org]);


  const handleErrors = (errorObj) => {
    const key = Object.keys(errorObj)[0];
    const value = errorObj[key];

    const existingIndex = errors.findIndex(
      (error) => Object.keys(error)[0] === key
    );

    if (existingIndex !== -1) {
      const updatedErrors = [...errors];
      updatedErrors[existingIndex][key] = value;
      setErrors(updatedErrors);
    } else {
      setErrors((prevErrors) => [...prevErrors, { [key]: value }]);
    }
  };

  return (
    <div className="max-w-[1920px] relative m-auto mt-[170px] pb-20">
      <div>
        <Sidebar />
      </div>
      <div className={`${isSidebarOpen?'ml-[300px]':'ml-[80px]'}`}>
        <div className=" rounded-lg  bg-[#E2F5EC]    w-full flex flex-col pb-[50px] shadow-[2px_2px_2px_-1px_rgb(0,0,0,0.1),-1px_-1px_4px_2px_rgb(0,0,0,0.1)] md:m-auto max-w-[900px] md:mt-[75px]">
          <div className="text-[22px] py-8 text-center font-medium leading-[42px]">
            {" "}
            Edit Meter
          </div>
          <div className="w-full">
            <InputBoxV2
              placeholder="Enter Meter No"
              id="test"
              type="text"
              validationtypes={["required"]}
              showError={formSubmitted}
              label={"Meter No"}
              value={name}
              fieldName={"Meter No"}
              setInputValue={setName}
              handleErrors={handleErrors}
            />
          </div>
          <br />
          <div className=" w-full">
            {" "}
            <ASelectv1
              label={"Select Organisation"}
              isflexed={true}
              // defaultValue={"Select option"}
              validationtypes={"required"}
              showError={formSubmitted}
              fieldName={"Organisation"}
              imputBoxMaxWidth={545}
              showLable={true}
              value={org}
              onChange={(e) => {
                setOrg(e.target.value);
              }}
              options={organisationList.map((organisation) => {
                return { label: organisation.name, value: organisation._id };
              })}
              handleErrors={handleErrors}
            />
          </div>
          <br />
          <br />
          <div className=" w-full">
            {" "}
            <ASelectv1
              label={"Select Factory"}
              isflexed={true}
              // defaultValue={"Select factory"}
              validationtypes={"required"}
              imputBoxMaxWidth={545}
              value={factory}
              fieldName={"Factory"}
              showError={formSubmitted}
              showLable={true}
              onChange={(e) => {
                setfactory(e.target.value);
              }}
              options={factorylist.map((factory) => {
                return { label: factory.name, value: factory._id };
              })}
              handleErrors={handleErrors}
            />
          </div>
          <br />

          <div className=" w-full">
            {" "}
            <ASelectv1
              label={"Select Unit"}
              isflexed={true}
              // defaultValue={"Select unit"}
              validationtypes={"required"}
              fieldName={"Existing Solar Rooftop"}
              imputBoxMaxWidth={545}
              value={unit}
              showError={formSubmitted}
              showLable={true}
              onChange={(e) => {
                setfactory(e.target.value);
              }}
              options={unitlist?.map((unit) => {
                return { label: unit.name, value: unit._id };
              })}
              handleErrors={handleErrors}
            />
          </div>
          <br />


          <div className=' flex w-full justify-center items-center text-center '>
            <div className='  flex items-center w-full'>
              <div className="  relative align-center rounded-lg text-left    ">
                <div
                  className="mx-[20px] sm:mx-[89px] xl:m-auto xl:w-[600px] pb-[40px] sm:pb-[40px] rounde"
                >
                  <div className="px-[14px] sm:px-[30px] font-normal text-left text-[16px] sm:text-[19px] leading-[24px] pt-[34px] sm:pt-[42px]">
                    Upload bills<span className="text-[red] ml-[4px]">*</span>
                  </div>
                  <div className="mt-[10px] w-full flex justify-center items-center ">
                    <img src="/uploadIcon.svg" />
                  </div>
                  <div className="mt-[18px] sm:px-[55px] sm:mt-[21px] pl-[14px] ml-[100px]">
                    <input
                      placeholder="Resume"
                      className="input-placeholder14 text-[14px] w-full bg-white border pt-[10px]  pl-[20px] rounded-[10px] h-[50px] border-[#B9B9B9]"
                      type="file"
                      value={otp}
                    />

                    {/* {isFormSubmitted && errors.otpErrorMsg && (
                      <p className="text-red-500 m-[10px]">
                        {errors.otpErrorMsg}
                      </p>
                    )} */}
                  </div>

                  <div className={`${optSuccess ? "block" : "hidden"}`}>
                    <div className="mt-[38px] font-[400] text-center text-[14px] leading-[21px]">
                      OTP verified successfully
                    </div>
                  </div>
                  <div className={`${isloading ? "block" : "hidden"}`}>
                    <div className="mt-[14px] flex justify-center text-center">
                      <svg
                        aria-hidden="true"
                        className="w-8 h-8 text-gray-200 animate-spin dark:text-gray-600 fill-green-600"
                        viewBox="0 0 100 101"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                          fill="currentColor"
                        />
                        <path
                          d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                          fill="currentFill"
                        />
                      </svg>
                    </div>
                    <div className="mt-[4px] font-[400] text-center text-[14px] leading-[21px]">
                      Loading...
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>

          <br />
          <div className="mt-[33px] w-full px-[14px] sm:px-[55px] sm:mt-[70px] flex font-normal justify-center gap-[80px]">
            <Abutton
              handleOnclick={handleSubmit}
              text={"Save & Next"}
              Mheight={44}
              Mwidth={170}
              DHeight={44}
              DWidth={299}
            />
            <Link to={'/my-data'}>
              <Abutton
                text={"Cancel"}
                Mheight={44}
                Mwidth={170}
                DHeight={44}
                DWidth={299}
              />
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddMeter;
